
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53.8 52.804"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)"}},[_c('rect',{attrs:{"data-name":"[bg]","width":"52.8","height":"51.804","rx":"6","fill":"#fff","stroke":"#d7d7d7","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Path 29597","d":"M13 12.804h26v26H13z","fill":"none"}}),_c('path',{attrs:{"data-name":"Path 29598","d":"M16 22.462v6.684h4.444L26 34.716V16.892l-5.556 5.57zm15 3.342a5.015 5.015 0 00-2.778-4.49v8.968A4.985 4.985 0 0031 25.804zm-2.778-9.77v2.295a7.807 7.807 0 010 14.95v2.295a10.025 10.025 0 000-19.54z","fill":"#757575"}})])])
          )
        }
      }
    